<template>
  <div class="function_wrap"  :style="!isPhone? 'width:1050px;':'width:95%'  " >
            <consult v-if="!isPhone"></consult>
            <div :class=" !isPhone? 'function_wrap box':'function_wrap box_mobile' " :style="'background-color: #fff; min-height:'+(screenHeight-80)+'px;'" >
                <!-- <div class="function_wrap_title">天数计算器</div> -->
                <h1 class="function_wrap_title">天数计算器/工作日天数计算</h1>
                <div class="function_wrap_title_EN">DAYS CALCULATOR</div>
                <!-- margin-right:0;border:1px solid #c41cc4; -->
               
                <div v-if="mode=='1' || mode=='3' " class='optionitem'   :style="isPhone?'width:100%':'' ">   
                     <!-- style="width:15%; margin-right:0;" -->
                    <div class="optionitem item_name">起止日期：</div>
                    <!-- <div class="optionitem item_detail" style="  background-color: #dcdfe6;
                    border-radius: 10px;"> 一般财产</div> -->
                  <div  class="optionitem item_detail" style="margin-left:0; " >
                        <el-date-picker
                            value-format="timestamp"
                            v-model="date1"
                            align="right"
                            type="date"
                            placeholder="选择日期"
                           
                            :style="isPhone?'':'width:30%;' "   
                            >
                        </el-date-picker>
                        <span  :style="isPhone?'margin: 10px 10px ':'margin: 0 10px 0 10px' "   >至</span>
             

                        <el-date-picker
                            value-format="timestamp"
                            v-model="date2"
                            type="date"
                            placeholder="选择日期"
                            :style="isPhone?'':'width:30%;' " >
                        </el-date-picker>


 


                    </div>

                </div>    



                
                <div class='optionitem' v-if="mode=='2' || mode=='4' "   :style="isPhone?'width:100%':'width:70%;' "    >  
                    <div class="optionitem item_name" style="width:15%;">开始日期：</div>
                      <el-date-picker
                            v-model="date3"
                            type="date"
                            placeholder="选择日期"
                            style="width:60%;margin:auto">
                        </el-date-picker>

                </div>    

                <div  class='optionitem' v-if="mode=='2' || mode=='4'" :style="isPhone?'width:100%':'width:70%;' "   >  
                    <div class="optionitem item_name" style="width:15%; ">天数间隔：</div>
                    <el-input type='number' min=0 v-model="days" placeholder="请输入天数间隔" style="width:60%;margin:auto"></el-input> 

                </div>   
           

                <el-radio-group v-model="mode" style="margin-top:50px">
                    <el-radio label="1" style="margin-top:15px">间隔天数</el-radio>
                    <el-radio label="2" style="margin-top:15px">日期推算</el-radio>
                    <el-radio label="3" style="margin-top:15px">间隔工作日 <el-badge   value="vip"    style="position:relative; left:-5px;font-size:10px;cursor:pointer" /></el-radio>
                    

                    <el-radio label="4" style="margin-top:15px">工作日推算<el-badge   value="vip"    style="position:relative; left:-5px;font-size:10px;cursor:pointer" /></el-radio>
                </el-radio-group> 

      

            



                <div  style="margin-top:60px">
                    <!-- <button @click="alert('ok')" type="button">Click Me!</button>
                    <button type="button">Cancle!</button> -->
                    <el-row>

                        <el-button @click="bindcalculate" type="primary" >确定</el-button>
                        <el-button @click="resetEvent" type="warning" style="margin-left: 50px;">清空</el-button>
                
                    </el-row> 
                </div>

       

                <img src="@/assets/images/ads/dayscal.png" alt="天数计算器"  class="hidden_img"   >



                <div class="result">
                    <h4>计算结果：</h4>
                    <p v-if="mode!=4" v-cloak style="margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp;计算结果：{{result}} </p>
                    <p v-if="mode==4 && detail.length>0" v-cloak style="margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp;计算结果：{{detail[detail.length-1].date}} </p>
                   
                    <p style="font-size:12px">结果仅供参考，请自行再次检查核实。 </p>
                </div>

               
                <el-table
                    :data="detail"
                    stripe
                    height="650"
                    style="width: 100%; ">
                    <el-table-column
                    prop="date"
                    label="日期"
                    width="180">
                    </el-table-column>
                    <el-table-column
                    prop="weekday"
                    label="星期几"
                    width="180">
                    </el-table-column>
                    <el-table-column
                    prop="desc"
                    label="说明">
                    </el-table-column>
                   
                </el-table>

                
                    

            </div>   





        </div>
</template>

<script>

import { IncUseNumber } from '@/assets/js/cal/cal';  

function isphone() {
	var sUserAgent = navigator.userAgent.toLowerCase();
	var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
	var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
	var bIsMidp = sUserAgent.match(/midp/i) == "midp";
	var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
	var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
	var bIsAndroid = sUserAgent.match(/android/i) == "android";
	var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
	var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
	if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid
			|| bIsCE || bIsWM) {
		return true
	} else {
		return false
	}
}


function toDate(number) {
  var n = number;
  var date = new Date(n);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? ('0' + m) : m;
  var d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
//   var h = date.getHours();
//   h = h < 10 ? ('0' + h) : h;
//   var minute = date.getMinutes();
//   var second = date.getSeconds();
//   minute = minute < 10 ? ('0' + minute) : minute;
//   second = second < 10 ? ('0' + second) : second;
  return y + '-'+m + '-' + d  
}
 import consult from '@/components/ads/consult.vue' 

export default {
        name: 'dalcal',
        metaInfo: {
            title: '天数计算器/工作日计算器', // set a title
            meta: [{                 // set meta
                name: 'keywords',
                content: '天数计算,工作日计算,律师咨询,法律工具'
            }],
      
        },
		props: {
            // isPhone: Boolean
        },
        components: { 
            consult
        
        },
        data() {
			return { 
                date1:'',
                date2:'',
                date3:'',
                result:0,
                mode:'1',
                days:0,
                detail:'',

                screenWidth:window.innerWidth,
			    screenHeight:window.innerHeight,
                isPhone:false,
            }
        },
        mounted(){
            IncUseNumber('dalcal')
            this.isPhone=isphone()
        },
        methods:{
            bindPickerChange(e){
                this.index=e.detail.value;
            },
            resetEvent(){
                this.result=0;
                this.date1='';
                this.date2='';
            },
            bindcalculate: function () {
                if(this.mode=='3' || this.mode=='4'){
                    if(!this.$store.state.islogin){
                        alert('工作日计算相关需要登录才可以使用');
                        return false;
                    }

                }
                if(this.mode=='1'){
                    if(!this.date1 || !this.date2 ){
                        alert('日期记得选择哦');
                        return false;
                    }
                    this.result=(this.date2-this.date1)/86400000;

                }

                else if(this.mode=='2'){
                    if(!this.date3  ){
                        alert('日期记得选择哦');
                        return false;
                    }

                   
                    var num=86400  //到秒 ,每天的秒数
                    var timestamp1 = Date.parse(this.date3)/1000
             
                    var final = timestamp1 + num * parseInt(this.days)
                    this.result=toDate(final*1000)


                   

                }
           

                else if(this.mode=='3' ){
                    var date=new Date();
                    var year = date.getFullYear()
                    let startDate=timestampToTime(this.date1)
                    let endDate=timestampToTime(this.date2)
                    console.log('startDate:',startDate)
                    console.log('endDate:',endDate)

                    var time_s2 = new Date( timestampToTime(this.date2).replace("-", "/").replace("-", "/"));
                    console.log('time_s2:',time_s2)
                    var limit_time= year+'/12/31'
                    var time_limit_time = new Date(limit_time.replace("-", "/").replace("-", "/"));

                    if(time_s2>time_limit_time){
                        // wx.showToast({
                        //     title: '截止日期不得大于今年',
                        //     icon: 'none'
                        // })
                        this.$message.error( '因暂无法获取来年节假日及调休安排，截止日期暂不得大于今年')
                        return
                    }

                    this.WorkDayCal('workday', {startDate:startDate,endDate:endDate } )

                }
                else if(this.mode=='4' ){
                    let startDate=timestampToTime(this.date3)
                    var date=new Date;
                    var year = date.getFullYear()
                    var num=86400000  //到秒 ,每天的秒数
                    // var timestamp1 = Date.parse(this.date3 )/1000
                    console.log(' this.date3:', this.date3)
                    var timestamp1 = Date.parse(this.date3 ) 
                    var final = timestamp1 + num * parseInt(this.days)

                    console.log("final:",final)
                    var endDate=timestampToTime(final)  //截止日期
                    console.log("截止日期：:",endDate)

                    var time_s2 = new Date(endDate.replace("-", "/").replace("-", "/"));
                    var limit_time= year+'/12/31'
                    var time_limit_time = new Date(limit_time.replace("-", "/").replace("-", "/"));

                    if(time_s2>time_limit_time){
                        this.$message.error( '因暂无法获取来年节假日及调休安排，截止日期暂不得大于今年')
                        return
                    }
                    
                    // var s3=(DateDiff(s1, s2))
                    // console.log('s3:',s3)
                    this.WorkDayCal('workdate', {startDate:startDate,gap:this.days} )

                }





                
            },

            WorkDayCal(mode,param){
                var data= { 
                    whattodo: "workday_cal",
                    mode:mode,
                    param:param,
                }
                var that=this
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let url= this.$root.rootUrl +'mini_app_vip'
                this.axios.post(url,data
                ).then(function (res) {
                    var result=res.data
                    window.console.log(res)
                    if(result.status=='badgate'){
                        that.$message({
                            message: '请先登录哦',
                            type: 'warning'
                        });

                    }else if(result.status=='ok'){
                        that.result=result.num
                        that.detail=result.data
       
                        
                    }else if(result.status=='fail'){
                        
                        that.$message.error( result.failMsg)
                        
                    }
                    loading.close();
                
                    
                }).catch(function (error) {
                    window.console.log(error);
                    loading.close();
                });

            }


        }

       


    }



    function   timestampToTime(timestamp) {
        var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var D = date.getDate() + '';
        // var h = date.getHours() + ':';   //
        // var m = date.getMinutes() + ':';//
        // var s = date.getSeconds();//
        if (M.length==1){
            M='0' +M
        }
        if (D.length==1){
            D='0' +D
        }
        return Y + M + D ;  //+ h + m + s
    }


</script>

<style>

el-date-picker{
    cursor: pointer;
}


.hidden_img{
    position: fixed;
    top:100px;
    z-index: -1;
    max-width: 950px;
    height: auto;
}
.el-date-editor--date{ 
    max-width: 200px; 
} 

</style>
